export default "__VITE_ASSET__i4O6SKLg__"